/**
 * Transforms StaticText data to i18n message structure
 * Handles multiple data formats from your API
 */
export function transformStaticTextToI18n(staticTextData) {
  const i18nMessages = {};

  if (Array.isArray(staticTextData)) {
    // Array format: [{ key: "cart.title", value: "Shopping cart" }, ...]
    staticTextData.forEach(textItem => {
      if (textItem.key && textItem.value) {
        setNestedValue(i18nMessages, textItem.key, textItem.value);
      }
    });
  } else if (typeof staticTextData === 'object' && staticTextData !== null) {
    // Object format: { "cart.title": "Shopping cart", ... }
    Object.keys(staticTextData).forEach(key => {
      const cleanKey = key.replace(/^'|'$/g, ''); // Remove surrounding quotes
      const value = staticTextData[key];

      // Handle nested objects or direct key-value pairs
      if (typeof value === 'object' && value !== null) {
        // If value is an object, merge it directly
        setNestedValue(i18nMessages, cleanKey, value);
      } else {
        // If value is a string, set it with dot notation support
        setNestedValue(i18nMessages, cleanKey, value);
      }
    });
  }

  return i18nMessages;
}

/**
 * Sets nested values in object using dot notation
 */
export function setNestedValue(obj, path, value) {
  // Handle direct object assignment
  if (typeof value === 'object' && value !== null && !path.includes('.')) {
    obj[path] = value;
    return;
  }

  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!(key in current) || typeof current[key] !== 'object') {
      current[key] = {};
    }
    current = current[key];
  }

  current[keys[keys.length - 1]] = value;
}

/**
 * Validates language configuration
 */
export function validateLanguageConfig(languages, defaultLanguage) {
  if (!Array.isArray(languages) || languages.length === 0) {
    console.warn('No languages provided');
    return false;
  }

  if (!defaultLanguage || !languages.some(lang => lang.code === defaultLanguage)) {
    console.warn('Default language not found in available languages');
    return false;
  }

  return true;
}
